// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f79F","left":"styles_left__3Jmyr","desktopActions":"styles_desktopActions__1pFfm","title":"styles_title__2ySbp"};